import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from '../core/http.service';
import { Observable } from 'rxjs';
import { GlobalsService } from '../globals.service';

@Injectable({
  providedIn: 'root'
})
export class TapTapAudiencesService {

  constructor(
    private httpService: HttpService,
    private globalsService: GlobalsService
  ) { }

  public getCategories(): Observable<string[]> {
    let url: string = `${environment.audiencesServicesApiBaseUri}/audiences/taptap/categories`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  }

  public getAudiences(categoryName: string): Observable<string[]> {
    let url: string = `${environment.audiencesServicesApiBaseUri}/audiences/taptap/categories/${categoryName}/audiences`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  }  

}